<template>

    <section aria-labelledby="timeline-title" class="lg:col-start-3 lg:col-span-1">
        <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
            <h2 id="timeline-title" class="text-lg font-medium text-gray-900">Události</h2>

            <!-- Activity Feed -->
            <div class="mt-6 flow-root">
                <ul role="list" class="-mb-8">
                    <TimelineItem v-for="(item, index) in log" :item="item" :last="(index === log.length-1)"/>
                </ul>
            </div>
            <div class="mt-6 flex flex-col justify-stretch">
                <button @click="showMore" type="button" class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Zobrazit více
                </button>
            </div>
        </div>
    </section>

</template>

<script>
import TimelineItem from "./TimelineItem";
export default {
    name: "TimelineComponent",
    components: {TimelineItem},
    props: ['detailed', 'paginated'],
    data(){
        return {
            log: this.$page.props.log,
            page: 0,
        };
    },
    methods: {
        showMore(){
            if(this.paginated){
                this.page++;
                axios.get(route('partner.timeline.page', {page: this.page}))
                    .then( (result) => {
                        this.log = this.log.concat(result.data.log);
                    });
            } else
                this.$inertia.get(route('partner.timeline'));
        }
    }
}
</script>

<style scoped>

</style>
